<script lang="ts">
    import { onMount } from "svelte";
    import { fly } from "svelte/transition";
    import ArrowRightIcon from "../icons/ArrowRightIcon.svelte";
    import PlusIcon from "../icons/PlusIcon.svelte";
    import Btn from "./Btn.svelte";
    import IconImg from "./IconImg.svelte";
    import Cookies from "js-cookie";
    import SinusWave from "../icons/SinusWaveIcon.svelte";
    import gsap from "gsap";
    import CloseIcon from "../icons/CloseIcon.svelte";
    import { t } from "../helpers/translation";

    let show = false;
    // setTimeout(() => (showAktuellesButton = true), 3000);
    // setTimeout(() => (showAktuellesButton = false), 10000);
    export let confirmedCookieName: string;
    export let heading: string;
    export let subline: string;
    export let fontSize: string = "1rem";
    export let startDate: Date;
    export let endDate: Date;
    export let width: string = "20em";
    export let height: string = "20em";
    export let padding: string = "3.5em";
    export let href: string = "";
    export let hrefText: string = "";

    onMount(() => {
        if (!startDate || !endDate) {
            console.error("startDate and endDate are required");
            return;
        }
        let today = new Date();

        if (today < startDate)
            return console.warn(
                confirmedCookieName + " ignored, today is before startDate",
            );

        if (today > endDate)
            return console.warn(
                confirmedCookieName + " ignored, today is after endDate",
            );

        const cookie = Cookies.get(confirmedCookieName);
        if (cookie == "true") return;

        setTimeout(() => {
            runAnimation();
        }, 3000);
    });

    function runAnimation() {
        const wavePath = document.querySelector<SVGPathElement>("#wave path");
        const infoText = document.querySelector("#info-text");

        show = true;

        gsap.set(infoText, {
            scale: 1,
            yPercent: -50,
            xPercent: 100,
        });

        const tl = gsap.timeline();

        tl.to(
            infoText,
            {
                xPercent: 15,
                ease: "power1.inOut",
                duration: 1,
            },
            ">-=.5",
        );

        setTimeout(() => {
            show = false;
            close();
        }, 3000_000);
    }

    function close(): void {
        const now = new Date();
        Cookies.set(confirmedCookieName, "true", {
            // expires: new Date(now.setMonth(now.getMonth() + CONFIRMED_COOKIE_REACTIVATE_MONTH)),
        });
        show = false;
    }
</script>

<div id="stoerer-wrapper" class:show>
    <div id="wave"><SinusWave /></div>
    <div
        id="info-text"
        style:font-size={fontSize}
        style:width
        style:height
        style:padding
    >
        <div class="content">
            <div class="heading">{heading}</div>
            <div class="subline">{subline}</div>
            <div class="info">
                <slot />
            </div>
            {#if href}
                <Btn arrow {href} on:click={close}>{hrefText}</Btn>
            {:else}
                <Btn size=".5em" on:click={close}>
                    {$t("special.stoerer.btn.close")}
                </Btn>
            {/if}
        </div>

        <a id="closepopup" on:click={close}>
            <IconImg svg={CloseIcon} />
        </a>
    </div>
</div>

<style lang="scss">
    @import "../src/vars";

    #info-text {
        font-size: 1.1rem;
        border-radius: 100000px;
        position: absolute;
        top: 35%;
        right: 0%;

        border: 0.33rem solid $yellow;
        background-color: $grayDark2;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-content: center;
        text-align: center;
        border-radius: 1000px;
        // box-shadow: 0 0 1em rgba($yellow, 0.5), inset 0 0 1em rgba($yellow, 0.3);
        z-index: 100;

        pointer-events: all !important;

        .content {
            font-size: 1.1em;
            margin: auto;
            max-width: 90%;
            display: flex;
            flex-direction: column;
            gap: 0.5em;
            justify-content: center;
            justify-items: center;
            align-items: center;
            align-content: center;
            > * {
                margin: none;
            }
            :global(a.btn) {
                font-size: 0.5em !important;
            }
            .heading {
                font-size: 1.5em;
                color: $green;
                font-weight: 800;
            }
            .subline {
                color: $grayLight;
            }
            .info {
                color: $gray;
                font-size: 0.6em;
                :global(p) {
                    color: $gray;
                    margin-top: 0;
                    font-size: inherit !important;
                    margin-bottom: 0.5em;
                }
                :global(a) {
                    color: $green;
                }
            }
        }

        #closepopup :global(.icon-wrapper) {
            font-size: 1.33em;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 50%);
            background-color: $yellow;
            color: $grayDark;
            fill: $grayDark;
            height: auto;
            padding: 0.33em;
            border-radius: 100%;
            cursor: pointer;
        }
    }

    #stoerer-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000000;
        // background-color: rgba(black, 0.5);

        opacity: 0;
        pointer-events: none;
        transition: 0.5s;

        display: none;
        &.show {
            display: block;
            // pointer-events: all;
            opacity: 1;
        }

        #wave {
            position: absolute;
            top: 50%;
            left: 0;
            width: 50%;
            height: auto;
            transform: scaleX(1) translateY(-50%);

            :global(svg) {
                overflow: visible;

                :global(path) {
                    opacity: 0;
                    stroke-width: 1em;
                    stroke: $yellow;
                    stroke-linecap: round;
                    fill: none;
                }
            }
        }
        #waveLight {
            :global(path) {
                stroke-width: 0.25em !important;
                stroke: $gray !important;
                opacity: 0;
            }
        }
        :global(strong) {
            color: $grayLight;
        }
    }
</style>
